/* global.js — core utilities shared across components.
   Keep section-specific logic out of here (see CLAUDE.md). */

window.allplants = window.allplants || {};

/**
 * Debounce: run `fn` after `wait`ms of inactivity. Used by scroll/resize handlers.
 * @param {Function} fn
 * @param {number} wait
 * @returns {Function}
 */
window.allplants.debounce = function debounce(fn, wait = 100) {
  let t;
  return function debounced(...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

/**
 * Run a callback once the DOM is ready (or immediately if it already is).
 * @param {Function} fn
 */
window.allplants.onReady = function onReady(fn) {
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", fn, { once: true });
  } else {
    fn();
  }
};
